import { useCallback, useState } from "react";
import { useDeleteAccount } from "@rentablo/api/apiv1";

export const useDeleteAccounts = () => {
  const { mutateAsync } = useDeleteAccount();
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteAccounts = useCallback(
    async (accountIds: number[]) => {
      setIsDeleting(true);
      try {
        return await Promise.allSettled(
          accountIds.map((id) => mutateAsync({ id }))
        );
      } finally {
        setIsDeleting(false);
      }
    },
    [mutateAsync]
  );

  return { deleteAccounts, isDeleting };
};
